import React from "react";
import ReactDOM from "react-dom/client";

// "/" is the marketing landing page: render it without the app (antd, redux,
// every classic page), which would otherwise make visitors download ~5 MB of
// JavaScript before the first paint. Every other URL loads the full app.
const root = ReactDOM.createRoot(document.getElementById("root"));

// Last-resort fallback if the app's own JS fails to load or parse (e.g. an old
// browser that can't parse a modern chunk). Without this the page is blank with
// no message. Plain DOM so it works without the React tree or any stylesheet.
const showBootFallback = (error) => {
  // eslint-disable-next-line no-console
  console.error("[app] failed to load", error, navigator.userAgent);
  const outdated =
    /ChunkLoadError|Loading chunk|module script failed|invalid group specifier|Invalid regular expression|Unexpected token|SyntaxError/i.test(
      `${(error && error.name) || ""} ${(error && error.message) || ""}`
    );
  const el = document.getElementById("root");
  if (!el) return;
  el.innerHTML =
    '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#f7f8fa;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;color:#1a1a1a">' +
    '<div style="max-width:460px;width:100%;background:#fff;border:1px solid #e6eaed;border-radius:12px;padding:32px;text-align:center;box-shadow:0 1px 3px rgba(0,0,0,0.06)">' +
    '<h1 style="font-size:20px;font-weight:600;margin:0 0 10px">' +
    (outdated ? "Please update your browser" : "Something went wrong") +
    "</h1>" +
    '<p style="font-size:14px;line-height:1.6;color:#525866;margin:0 0 22px">' +
    (outdated
      ? "This page needs a newer browser. If you're on Safari, update to version 16.4 or later (or use the latest Chrome), then reload."
      : "The app failed to load. Reloading usually fixes it. If it keeps happening, please contact support.") +
    "</p>" +
    '<button type="button" onclick="window.location.reload()" style="background:#111;color:#fff;border:none;border-radius:8px;padding:10px 22px;font-size:14px;font-weight:500;cursor:pointer">Reload</button>' +
    "</div></div>";
};

if (window.location.pathname === "/") {
  const landing = () => import("./public/landing/LandingPage");
  const mount = () => landing().then(({ default: LandingPage }) => root.render(<LandingPage />)).catch(showBootFallback);
  if (document.getElementById("root").childElementCount) {
    // robomarketer.com serves a prerendered copy of the landing (seo/home-snapshot.html).
    // Swap in the live React page on the first interaction instead of at load, so the
    // static copy stays the page's first and largest paint. Fetch the code while idle.
    (window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(() => landing());
    const events = ["pointerdown", "keydown", "scroll", "touchstart", "mousemove"];
    const once = () => {
      events.forEach((e) => window.removeEventListener(e, once));
      mount();
    };
    events.forEach((e) => window.addEventListener(e, once, { passive: true }));
  } else {
    mount();
  }
} else {
  import("./AppRoot")
    .then(({ default: AppRoot }) => root.render(<AppRoot />))
    .catch(showBootFallback);
}
